import { render, staticRenderFns } from "../../templates/form/farm-user-form.pug?vue&type=template&id=113d8537&lang=pug&"
import script from "./FarmUserForm.vue?vue&type=script&lang=js&"
export * from "./FarmUserForm.vue?vue&type=script&lang=js&"
import style0 from "./FarmUserForm.vue?vue&type=style&index=0&id=113d8537&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports